import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Button,
  Typography,
  Skeleton,
  SkeletonBlock,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';

export const SweepstakesDrawer = ({
  isOpen,
  onClose,
  onBack,
  drawerTitle,
  sweepstakesTitle,
  logoUrl,
  heroImage,
  children,
  footerContent,
  isLoading,
  hasError,
  testId,
}) => {
  if (!isOpen) return null;

  return (
    <Drawer open={isOpen} onClose={onClose} data-testid="sweepstakes-drawer">
      <DrawerHeader
        title={drawerTitle}
        onClose={onClose}
        onBack={onBack}
        data-testid={testId}
      />
      <DrawerBody>
        {isLoading && (
          <div data-testid="sweepstakes-drawer-loading">
            <Skeleton>
              <SkeletonBlock />
              <SkeletonLine />
              <SkeletonLine />
            </Skeleton>
          </div>
        )}
        {!isLoading && hasError && (
          <div className="sui-text-center sui-py-8" data-testid="sweepstakes-drawer-error">
            <Typography variant="h3" weight="display" height="tight" color="danger">
              Error loading sweepstakes
            </Typography>
            <div className="sui-mt-2">
              <Typography variant="body-base" color="subtle">
                Please try again later.
              </Typography>
            </div>
          </div>
        )}
        {!isLoading && !hasError && (
          <div>
            {heroImage && (
              <div className="sui-mb-6">
                <img
                  src={heroImage}
                  alt="Hero"
                  className="sui-w-full sui-rounded-lg"
                  width="957"
                  height="262"
                />
              </div>
            )}
            {(logoUrl || sweepstakesTitle) && (
              <div className="sui-flex sui-items-start sui-gap-3 sui-mb-4">
                {logoUrl && (
                  <img
                    src={logoUrl}
                    alt="Logo"
                    className="sui-w-12 sui-h-12 sui-flex-shrink-0 sui-mt-1"
                    width="48"
                    height="48"
                  />
                )}
                {sweepstakesTitle && (
                  <Typography variant="h2" weight="display" height="tight">{sweepstakesTitle}</Typography>
                )}
              </div>
            )}
            {children}
          </div>
        )}
      </DrawerBody>
      {footerContent && (
        <DrawerFooter variant="sticky">
          {footerContent}
        </DrawerFooter>
      )}
    </Drawer>
  );
};

SweepstakesDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  drawerTitle: PropTypes.string,
  sweepstakesTitle: PropTypes.string,
  logoUrl: PropTypes.string,
  heroImage: PropTypes.string,
  children: PropTypes.node,
  footerContent: PropTypes.node,
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
  testId: PropTypes.string,
};

SweepstakesDrawer.defaultProps = {
  onBack: null,
  drawerTitle: null,
  sweepstakesTitle: null,
  logoUrl: null,
  heroImage: null,
  children: null,
  footerContent: null,
  isLoading: false,
  hasError: false,
  testId: null,
};